module.exports = __webpack_public_path__ + "img/168.e760bd46.jpg";